export default __webpack_public_path__ + "static/media/388.088c52b7.png";